import { translations } from '../translations';

const item = (item, { html }) => {
    const typeHandle = item.entry_type_handle;
    const mainCategoryField = `type_${typeHandle}`;
    const typeLabels = [item.entry_type, ...(item[mainCategoryField] ?? [])];

    const highlightedModalities = ['Digital / online', 'Hybrid'];

    const address = [
        item.address?.organization,
        item.address?.addressLine1,
        item.address?.addressLine2,
        [item.address?.postalCode, item.address?.locality].filter(Boolean).join(' '),
    ].filter(Boolean);
    const addressParagraph = address.join('\n');

    const mediaFields = ['media_author', 'media_publisher', 'media_publishing_company'].filter(
        field => item[field],
    );
    const dateRange = [item.date_start, item.date_end].filter(Boolean);

    const previewImageFields = ['user_logo', 'user_image', 'image'].filter(field => field in item);
    const previewImage = previewImageFields.length ? item[previewImageFields[0]] : null;

    const description = item.description_medium || item.description_short;

    return html`
        <article class="search-result">
            <p class="search-result__type">
                ${typeLabels.map(
                    label => html`<span class="search-result__type-badge">${label}</span>`,
                )}
                ${item.modality && highlightedModalities.includes(item.modality)
                    ? html`<span
                          class="search-result__type-badge search-result__type-badge--highlight"
                          >${item.modality}</span
                      >`
                    : ''}
            </p>
            <div class="row">
                <div class="col-xl-5">
                    <h2 class="search-result__title">
                        <a class="search-result__link" href="${item.url}">${item.title}</a>
                    </h2>
                    ${item.header_text
                        ? html`<p class="search-result__subtitle">${item.header_text}</p>`
                        : ''}
                </div>
                <div class="${previewImage ? 'col-lg-7 col-xl-4' : 'col-xl-7'}">
                    ${description
                        ? html`<p class="search-result__description">${description}</p>`
                        : ''}
                    ${dateRange.length
                        ? html`<p class="search-result__dates">${dateRange.join(' – ')}</p>`
                        : ''}
                    ${addressParagraph
                        ? html`<p class="search-result__address">${addressParagraph}</p>`
                        : ''}
                    ${mediaFields.length
                        ? html`<p class="search-result__media-info">
                              ${mediaFields.map(
                                  (field, index) => html`
                                      <strong class="search-result__media-info-label"
                                          >${translations.fieldLabels[field]}:
                                      </strong>
                                      <span class="search-result__media-info-content"
                                          >${item[field]}</span
                                      >
                                      ${index == mediaFields.length ? '' : html`<br />`}
                                  `,
                              )}
                          </p>`
                        : ''}
                </div>
                ${previewImage
                    ? html`
                          <div
                              class="col-lg-5 col-xl-3 align-self-end align-self-xl-start text-lg-end"
                          >
                              <img
                                  class="search-result__image"
                                  src="${previewImage.preview_url}"
                                  width="${previewImage.preview_width}"
                                  height="${previewImage.preview_height}"
                                  alt="${previewImage.alt || ''}"
                              />
                          </div>
                      `
                    : ''}
            </div>
        </article>
    `;
};

const empty = (data, { html }) => {
    return html`<p class="alert alert-warning">${translations.noResultsWarning}</p>`;
};

const showMoreText = (data, { html }) => {
    return html`${translations.infiniteHitsShowMoreText}`;
};

export default {
    item,
    empty,
    showMoreText,
};
